const shareButton = document.querySelector(".js--share-button");

if (shareButton) {
  const shareContainer = document.querySelector(".share-container");

  shareButton.addEventListener("click", () => {
    shareContainer.classList.toggle("active");
  });
}
